import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SuggestionsContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[1],
}));

const SuggestionChips = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  fontWeight: 500,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    boxShadow: theme.shadows[2],
  },
  transition: 'all 0.2s ease',
}));

const suggestedQuestions = [
  'How does Laprecio work?',
  'How do I register?',
  'What minerals can be traded?',
  'How secure is trading?',
  'What compliance standards are supported?',
  'How to contact support?'
];

const SuggestedQuestions = ({ onSelectQuestion }) => {
  return (
    <SuggestionsContainer>
      <Typography variant="body2" fontWeight="medium" color="text.secondary">
        Suggested questions:
      </Typography>
      <SuggestionChips>
        {suggestedQuestions.map((question, index) => (
          <StyledChip
            key={index}
            label={question}
            onClick={() => onSelectQuestion(question)}
            clickable
            size="small"
          />
        ))}
      </SuggestionChips>
    </SuggestionsContainer>
  );
};

export default SuggestedQuestions;
